"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedInLogo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.75 20.8636H17.4402V14.6318C17.4402 13.0006 16.7661 11.887 15.2836 11.887C14.1497 11.887 13.5191 12.6385 13.2256 13.3627C13.1156 13.6227 13.1328 13.9848 13.1328 14.3469V20.8636H8.86313C8.86313 20.8636 8.91816 9.82452 8.86313 8.82107H13.1328V10.7111C13.385 9.88469 14.7493 8.70528 16.9266 8.70528C19.6278 8.70528 21.75 10.4375 21.75 14.1675V20.8636ZM4.54533 7.31476H4.51782C3.14199 7.31476 2.25 6.39416 2.25 5.22725C2.25 4.03764 3.16836 3.13635 4.5717 3.13635C5.97389 3.13635 6.83608 4.03538 6.86359 5.22386C6.86359 6.39077 5.97389 7.31476 4.54533 7.31476ZM2.74184 8.82107H6.54257V20.8636H2.74184V8.82107Z", fill: "black" }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 27.8181H23.2536V19.509C23.2536 17.3341 22.3548 15.8494 20.3782 15.8494C18.8663 15.8494 18.0255 16.8513 17.6342 17.8169C17.4874 18.1635 17.5103 18.6463 17.5103 19.1291V27.8181H11.8175C11.8175 27.8181 11.8909 13.0993 11.8175 11.7614H17.5103V14.2814C17.8467 13.1795 19.6658 11.607 22.5688 11.607C26.1704 11.607 29 13.9166 29 18.89V27.8181ZM6.06044 9.75297H6.02376C4.18933 9.75297 3 8.52551 3 6.96963C3 5.38348 4.22448 4.18176 6.0956 4.18176C7.96519 4.18176 9.11477 5.38047 9.15146 6.9651C9.15146 8.52098 7.96519 9.75297 6.06044 9.75297ZM3.65579 11.7614H8.72342V27.8181H3.65579V11.7614Z", fill: "black" }, void 0) }), void 0));
};
var LinkedInLogo = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.LinkedInLogo = LinkedInLogo;
//# sourceMappingURL=LinkedInLogo.js.map